import { MaskedText, Reveal, FadeIn } from "@/components/motion/Reveal";
import { ContactForm } from "@/components/ContactForm";
import { CONTACT_EMAIL, LOCATION } from "@/data/content";

export default function Contact() {
  return (
    <>
      <section className="px-6 pb-16 pt-36 md:px-12 md:pt-48">
        <div className="mx-auto max-w-[1400px]">
          <FadeIn>
            <p className="overline mb-8 flex items-center gap-3 text-muted">
              <span className="h-px w-10 bg-clay" />
              Contact — Stylist
            </p>
          </FadeIn>
          <MaskedText
            lines={["Get in", "Touch"]}
            className="font-display text-[12vw] font-extralight leading-[0.9] tracking-tight text-ink md:text-[8vw]"
          />
        </div>
      </section>

      <section className="px-6 pb-32 md:px-12">
        <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 lg:grid-cols-12">
          <div className="order-2 lg:order-1 lg:col-span-4">
            <Reveal>
              <p className="overline mb-4 text-muted">Direct</p>
              <a href={`mailto:${CONTACT_EMAIL}`} data-testid="contact-email-link" className="link-underline font-body text-base">
                {CONTACT_EMAIL}
              </a>
              <p className="mt-8 overline text-muted">Based</p>
              <p className="mt-1 font-body text-base text-ink">{LOCATION}</p>

              <div className="mt-10 border-t border-hairline pt-6">
                <p className="overline mb-3 text-muted">Portfolio</p>
                <p data-testid="portfolio-note" className="font-display text-xl font-extralight leading-snug tracking-tight text-ink">
                  Want the full portfolio? Just ask.
                </p>
              </div>

              <p className="mt-10 max-w-xs font-body text-sm leading-relaxed text-stone">
                Tell me about the project — deliverables, timeline, the vibe. The more you
                share, the better I can help.
              </p>
            </Reveal>
          </div>

          <div className="order-1 lg:order-2 lg:col-span-8">
            <ContactForm section="Stylist" />
          </div>
        </div>
      </section>
    </>
  );
}
